import './style.scss'
import { Modal } from 'antd'
import { FC, memo } from 'react'
import { showPlanModal, urlSource } from '@/libs/util'
import { CloseCircleOutlined } from '@ant-design/icons'

interface IProps {
  open: boolean
  onCancel?: () => void
}

const Coupon: FC<IProps> = (props) => {
  const { open, onCancel } = props

  const toUse = () => {
    showPlanModal()
    onClose()
  }

  const onClose = () => {
    onCancel?.()
  }

  return (
    <>
      <Modal
        maskClosable={false}
        closeIcon={null}
        className={`coupon-modal`}
        onCancel={onClose}
        footer={null}
        width={300}
        open={open}
      >
        <div className="coupon-modal-content">
          <img
            className="img-coupon"
            src={urlSource('hiflys/point-activity/images/modal-coupon-0604.webp')}
            onClick={toUse}
          />
          <CloseCircleOutlined onClick={onClose} />
        </div>
      </Modal>
    </>
  )
}

export default memo(Coupon)
